import React from 'react';
import {
  Box,
  Skeleton,
  Divider,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

const SkeletonItem = ({ showDivider = true }) => (
  <Box>
    <Box sx={{ py: 3, px: 2 }}>
      {/* Name and status row */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="text" width={120} height={24} />
        </Box>
        <Skeleton variant="rounded" width={80} height={24} />
      </Box>

      {/* Unit info */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, ml: 3 }}>
        <Skeleton variant="circular" width={16} height={16} />
        <Skeleton variant="text" width={60} height={20} />
      </Box>

      {/* Bed/Bath info */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, ml: 3 }}>
        <Skeleton variant="circular" width={16} height={16} />
        <Skeleton variant="text" width={80} height={20} />
      </Box>

      {/* Date range */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 3 }}>
        <Skeleton variant="circular" width={16} height={16} />
        <Skeleton variant="text" width={200} height={20} />
      </Box>
    </Box>

    {showDivider && <Divider />}
  </Box>
);

const HouseholdModalSkeleton = () => (
  <Box>
    <SkeletonItem />
    <SkeletonItem />
    <SkeletonItem showDivider={false} />
  </Box>
);

export default HouseholdModalSkeleton;
